import React from 'react';
import { FormattedMessage } from 'react-intl';

// Actions
export const DISPLAY_TOASTER = 'DISPLAY_TOASTER';
export const HIDE_TOASTER = 'HIDE_TOASTER';

// Failure Message Types
export const DANGER_TOASTER = 'DANGER_TOASTER';
export const NON_DISMISSIBLE_DANGER_TOASTER = 'NON_DISMISSIBLE_DANGER_TOASTER';
export const WARNING_TOASTER = 'WARNING_TOASTER';
export const CUSTOM_TOASTER = 'CUSTOM_TOASTER';

// Action Creators
export function displayToaster(type, content, location = 'app', visibilityTimeout, isDismissible) {
  return {
    type: DISPLAY_TOASTER,
    payload: {
      type,
      content,
      visible: true,
      location,
      visibilityTimeout,
      isDismissible,
    },
  };
}

export function displayFailureToaster(context, failureMessage = {}) {
  const { type = DANGER_TOASTER, customComponent = null } = failureMessage;
  return (dispatch, getState) => {
    const { appState: { drawer } } = getState();
    const location = drawer.isOpen ? 'drawer' : 'app';
    let severity;
    let errorNode;
    let timeout;
    let dismissible;
    switch (type) {
      default: // Default to most severe error toaster
      case NON_DISMISSIBLE_DANGER_TOASTER:
        errorNode = (
          <span>
            <FormattedMessage id="THERE_WAS_A_PROBLEM" />
            <span>&nbsp;</span>
            <FormattedMessage id={context} />
            <span>.&nbsp;</span>
            <FormattedMessage id="PLEASE_TRY_AGAIN_LATER" />
          </span>
        );
        severity = 'danger';
        timeout = null;
        dismissible = false;
        break;
      case DANGER_TOASTER:
        errorNode = (
          <span>
            <FormattedMessage id="THERE_WAS_A_PROBLEM" />
            <span>&nbsp;</span>
            <FormattedMessage id={context} />
            <span>.&nbsp;</span>
            <FormattedMessage id="PLEASE_TRY_AGAIN_LATER" />
          </span>
        );
        severity = 'danger';
        timeout = null;
        dismissible = true;
        break;
      case WARNING_TOASTER:
        errorNode = (
          <span>
            <FormattedMessage id="THERE_WAS_A_PROBLEM" />
            <span>&nbsp;</span>
            <FormattedMessage id={context} />
            <span>.&nbsp;</span>
            <FormattedMessage id="SOME_FEATURES_MAY_NOT_BE_AVAILABLE" />
          </span>
        );
        severity = 'warning';
        timeout = null;
        dismissible = true;
        break;
      case CUSTOM_TOASTER:
        errorNode = customComponent;
        ({ severity = 'info', timeout = 5000, dismissible = true } = failureMessage);
        break;
    }
    dispatch(displayToaster(
      severity,
      errorNode,
      location,
      timeout, /* visibilityTimeout */
      dismissible /* isDismissible */
    ));
  };
}

export function hideToaster(location) {
  return {
    type: HIDE_TOASTER,
    payload: {
      visible: false,
      location,
    },
  };
}

// Reducer
const INITIAL_STATE = {
  drawer: {
    visible: false,
    type: 'danger',
    content: null,
  },
  app: {
    visible: false,
    type: '',
    content: null,
  },
};

export function toaster(state = INITIAL_STATE, action) {
  switch (action.type) {
    case HIDE_TOASTER: {
      const {
        payload: {
          location,
          visible,
        },
      } = action;
      const locationData = state[location];
      return {
        ...state,
        [location]: {
          ...locationData,
          visible,
        },
      };
    }
    case DISPLAY_TOASTER: {
      const {
        payload: {
          type,
          content,
          labelAlias,
          visible,
          location,
          isDismissible,
          visibilityTimeout,
        },
      } = action;

      const { type: priorType = '', visible: priorVisible = false } = state[location];
      // if there's already an error toaster
      // make sure our new one is at least equally important before replacing the old one
      // we should explore showing multiple toasters at the same time
      if (priorVisible) {
        if (priorType === 'danger') {
          if (type !== 'danger') {
            return state;
          }
        } else if (priorType === 'warning') {
          if (type !== 'danger' && type !== 'warning') {
            return state;
          }
        }
      }
      return {
        ...state,
        [location]: {
          visible,
          type,
          labelAlias,
          content,
          isDismissible,
          visibilityTimeout,
        },
      };
    }
    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/modules/toaster/toaster.js